<template>
  <form @submit.prevent="handleSubmit">
    <modal-card title="Upload file">
      <video width="100%" controls v-if="type == 'video'">
        <source :src="src" type="video/mp4">
        <source :src="src" type="video/ogg">
        Your browser does not support HTML5 video.
      </video>
      <embed :src="src" width="100%" height="800" type="application/pdf" v-else-if="type == 'pdf'">
      <div v-else-if="type == 'zip'">

      </div>
      <div slot="foot">
        <upload-file
          ref="uploader"
          :file-field-name="config.fileFieldName"
          file-name="image.jpg"
          :additional="config.additional"
          :endpoint="config.endpoint"
          @uploaded="uploaded"
        >
          <template slot-scope="{ progress }">
            <button type="submit" class="button" @click="$parent.close()">Cancel</button>

            <button
              class="button is-primary"
              :class="{
                'is-loading': progress !== null
              }"
            >Upload</button>
          </template>
        </upload-file>
      </div>
    </modal-card>
  </form>
</template>

<script>
import UploadFile from "./UploadFile";

export default {
  components: {
    UploadFile
  },

  props: {
    config: {
      type: Object,
      required: true
    },

    file: {
      required: true
    },

    type: {
      type: String,
      required: true
    },

    whenUploaded: {
      type: Function
    }
  },

  data() {
    return {
      uploading: false
    };
  },

  computed: {
    src() {
      return URL.createObjectURL(this.file);
    }
  },

  methods: {
    handleSubmit() {
      this.$refs.uploader.upload(this.file);
    },

    uploaded({ data: image }) {
      this.whenUploaded(image);

      this.$parent.close();
    }
  }
};
</script>
